<template>
  <div class="login">
    <!-- <div v-if="flag" @click="boxFlag = true">选择角色</div> -->
    <!-- <div v-else style="text-align: left">欢迎 {{ name }}</div> -->
    <div class="box" v-if="flag">
      <!-- <div class="line">
        <p>姓名：</p>
        <el-input v-model="name" placeholder="请输入名称"></el-input>
      </div> -->

      <div class="line">
        <p>请选择角色：</p>
        <div class="roleBox">
          <div v-for="(item, index) in roleList" :key="index" @click="roleValue = index">
            <img :src="item" :class="['avatar', index == roleValue ? 'active' : '']" />
          </div>
        </div>
      </div>
      <div class="line1">
        <el-button type="primary" @click="loginIn">确认</el-button>
        <el-button
          @click="
            boxFlag = false;
            roleValue = 0;
          "
          >取消</el-button
        >
      </div>
    </div>
    <!-- <audio id="stream" autoplay style="width: 0"></audio> -->
  </div>
</template>
<script>
import Bus from "../../common/js/bus";
export default {
  data() {
    return {
      flag: true,
      num: 1,
      name: "",
      roleList: [
        require("../assets/img/role1.jpg"),
        require("../assets/img/role2.jpg"),
        require("../assets/img/role3.png"),
        require("../assets/img/role4.png"),
        require("../assets/img/role5.jpg"),
        require("../assets/img/role6.jpg"),
      ],
      roleValue: 0,
      boxFlag: false,
      value: false,
      value1: false,
      list: [],
      audioFlag: true,
      adminFlag: false,
      timmer: "",
      loginFlag: false,
      endnum: 300,
      outflag: false,
    };
  },
  methods: {
    loginIn() {
      if (document.o2.login) document.o2.login("123123", this.room_id, this.roleValue);
      // alert(this.roleValue);
      if (this.name == "admin_") {
        this.adminFlag = true;
      }
      // this.$message({
      //   type: "success",
      //   message: "登录成功," + this.name,
      // });

      localStorage.setItem("roleValue", this.roleValue);
      this.flag = false;
      this.boxFlag = false;
      this.roleValue = 0;
    },
  },

  created() {
    document.addEventListener("click", this.online, false);
    document.addEventListener("keydown", this.online, false);
    // const query = QS.parse(location.hash.substring(3));
    // var id = query.id;
    this.room_id = 1234567;

    Bus.$on("ylogin", () => {
      if (localStorage.getItem("roleValue")) {
        this.flag = false;
        this.roleValue = localStorage.getItem("roleValue");
        this.loginIn();
      }
    });
  },
  destroyed() {
    document.removeEventListener("click", this.online, false);
    document.removeEventListener("keydown", this.online, false);
  },
};
</script>

<style lang="scss" scoped>
.shadow {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  z-index: 95;
}
.login {
  position: absolute;
  top: 20px;
  color: #fff;
  left: 40px;
  z-index: 1;
  font-family: Source Han Sans TC;
  cursor: pointer;

  ::v-deep.el-switch__label {
    color: white;
  }
  ::v-deep.el-switch__label.is-active {
    color: #409eff;
  }
}
.box {
  width: 350px;
  height: 210px;
  background: #ffffff;
  box-shadow: 1px 3px 17px 1px rgba(66, 84, 142, 0.31);
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  .line1 {
    // float: right;
    // margin-right: 20px;
    // margin-top: 20px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  .line {
    display: flex;
    align-items: center;
    margin: 20px 0;
    p {
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #666;
      margin-left: 20px;
    }
    .el-input {
      width: 200px;
      margin: 15px;
    }
    .roleBox {
      display: flex;
      width: 250px;
      flex-wrap: wrap;
      .avatar {
        width: 50px;
        height: 50px;
        border: 2px solid #bebebe;
        border-radius: 50%;
        margin-left: 20px;
      }
      .active {
        border: 2px solid #409eff;
        transition: 0.5s;
      }
    }
  }
}
.audioList {
  width: 190px;
  height: 458px;
  background: rgba($color: #fff, $alpha: 0.5);
  box-shadow: 1px 3px 17px 1px rgba(66, 84, 142, 0.31);
  border-radius: 8px;
  position: absolute;
  right: 0px;
  top: 120px;

  .list:first-of-type {
    margin-top: 10px;
  }
  .list {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 40px;
    p {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #333333;
      width: 100px;
      text-align: left;
    }
    .img {
      width: 14px;
      height: 21px;
      position: relative;
      .black {
        width: 8px;
        height: 14px;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        background-color: black;
        border-radius: 4px;
        overflow: hidden;
        top: 0;
        position: relative;
        .green {
          width: 100%;
          background: #00ff00;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .login {
    font-size: 12px;
    right: 20px;
    top: 17px;
  }
}
</style>
